var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParkingScene(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 124.17,
    height: 101.62,
    viewBox: "0 0 124.17 101.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "aparcamiento",
    transform: "translate(-0.001 -7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_24",
    "data-name": "Grupo 24",
    transform: "translate(0.005 104.555)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_137",
    "data-name": "Trazado 137",
    d: "M122.229,59.065H1.943a2.035,2.035,0,0,1,0-4.065H122.229a2.035,2.035,0,0,1,0,4.065Z",
    transform: "translate(-0.003 -55)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25",
    "data-name": "Grupo 25",
    transform: "translate(120.291 41.526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_138",
    "data-name": "Trazado 138",
    d: "M63.939,91.081A1.986,1.986,0,0,1,62,89.049V26.02a1.942,1.942,0,1,1,3.88,0V89.049A1.986,1.986,0,0,1,63.939,91.081Z",
    transform: "translate(-61.999 -23.988)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_26",
    "data-name": "Grupo 26",
    transform: "translate(81.486 41.526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_139",
    "data-name": "Trazado 139",
    d: "M43.939,91.081A1.986,1.986,0,0,1,42,89.049V26.02a1.942,1.942,0,1,1,3.88,0V89.049A1.986,1.986,0,0,1,43.939,91.081Z",
    transform: "translate(-41.999 -23.988)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_27",
    "data-name": "Grupo 27",
    transform: "translate(38.805 41.526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_140",
    "data-name": "Trazado 140",
    d: "M21.941,91.081A1.986,1.986,0,0,1,20,89.049V26.02a1.942,1.942,0,1,1,3.88,0V89.049A1.986,1.986,0,0,1,21.941,91.081Z",
    transform: "translate(-20.001 -23.988)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_28",
    "data-name": "Grupo 28",
    transform: "translate(0.001 41.526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_141",
    "data-name": "Trazado 141",
    d: "M1.941,91.081A1.986,1.986,0,0,1,0,89.049V26.02a1.986,1.986,0,0,1,1.94-2.032,1.986,1.986,0,0,1,1.94,2.032V89.049a1.986,1.986,0,0,1-1.94,2.032Z",
    transform: "translate(-0.001 -23.988)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_29",
    "data-name": "Grupo 29",
    transform: "translate(116.412 41.526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_142",
    "data-name": "Trazado 142",
    d: "M65.819,28.053H61.94a2.035,2.035,0,0,1,0-4.065h3.878a2.035,2.035,0,0,1,0,4.065Z",
    transform: "translate(-60 -23.988)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_30",
    "data-name": "Grupo 30",
    transform: "translate(0.003 41.526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_143",
    "data-name": "Trazado 143",
    d: "M5.821,28.053H1.942a2.035,2.035,0,0,1,0-4.065H5.821a2.035,2.035,0,0,1,0,4.065Z",
    transform: "translate(-0.002 -23.988)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_31",
    "data-name": "Grupo 31",
    transform: "translate(77.606 41.526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_144",
    "data-name": "Trazado 144",
    d: "M49.7,28.053H41.939a2.035,2.035,0,0,1,0-4.065H49.7a2.035,2.035,0,0,1,0,4.065Z",
    transform: "translate(-39.999 -23.988)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_32",
    "data-name": "Grupo 32",
    transform: "translate(34.927 41.526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_145",
    "data-name": "Trazado 145",
    d: "M27.705,28.053H19.942a2.035,2.035,0,0,1,0-4.065h7.763a2.035,2.035,0,0,1,0,4.065Z",
    transform: "translate(-18.002 -23.988)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_51",
    "data-name": "Grupo 51",
    transform: "translate(87.311 49.701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_36",
    "data-name": "Grupo 36",
    transform: "translate(1.94 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_33",
    "data-name": "Grupo 33",
    transform: "translate(0.002 4.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_146",
    "data-name": "Trazado 146",
    d: "M47.942,68.593A1.986,1.986,0,0,1,46,66.561V32.042a1.942,1.942,0,1,1,3.88,0V66.561A1.986,1.986,0,0,1,47.942,68.593Z",
    transform: "translate(-46.002 -30.01)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_34",
    "data-name": "Grupo 34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_147",
    "data-name": "Trazado 147",
    d: "M47.941,36.14A1.986,1.986,0,0,1,46,34.107a5.973,5.973,0,0,1,5.823-6.1,2.035,2.035,0,0,1,0,4.065,1.99,1.99,0,0,0-1.942,2.032A1.986,1.986,0,0,1,47.941,36.14Z",
    transform: "translate(-46.001 -28.01)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_35",
    "data-name": "Grupo 35",
    transform: "translate(0.002 38.583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_148",
    "data-name": "Trazado 148",
    d: "M55.7,59.188a9.429,9.429,0,0,1-6.861-2.973A10.338,10.338,0,0,1,46,49.026a1.942,1.942,0,1,1,3.88,0,6.2,6.2,0,0,0,1.7,4.313A5.652,5.652,0,0,0,55.7,55.124a2.035,2.035,0,0,1,0,4.065Z",
    transform: "translate(-46.002 -46.994)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_40",
    "data-name": "Grupo 40",
    transform: "translate(17.458 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_37",
    "data-name": "Grupo 37",
    transform: "translate(7.763 4.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_149",
    "data-name": "Trazado 149",
    d: "M59.94,68.593A1.986,1.986,0,0,1,58,66.561V32.042a1.942,1.942,0,1,1,3.88,0V66.561A1.986,1.986,0,0,1,59.94,68.593Z",
    transform: "translate(-58 -30.01)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_38",
    "data-name": "Grupo 38",
    transform: "translate(3.882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_150",
    "data-name": "Trazado 150",
    d: "M61.821,36.14a1.986,1.986,0,0,1-1.94-2.032,1.989,1.989,0,0,0-1.94-2.032,2.035,2.035,0,0,1,0-4.065,5.971,5.971,0,0,1,5.821,6.1A1.986,1.986,0,0,1,61.821,36.14Z",
    transform: "translate(-56 -28.01)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_39",
    "data-name": "Grupo 39",
    transform: "translate(0 38.583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_151",
    "data-name": "Trazado 151",
    d: "M55.939,59.188a2.035,2.035,0,0,1,0-4.065,5.973,5.973,0,0,0,5.823-6.1,1.942,1.942,0,1,1,3.88,0A9.951,9.951,0,0,1,55.939,59.188Z",
    transform: "translate(-53.999 -46.994)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_41",
    "data-name": "Grupo 41",
    transform: "translate(5.823 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_152",
    "data-name": "Trazado 152",
    d: "M65.46,32.075H49.942a2.035,2.035,0,0,1,0-4.065H65.46a2.035,2.035,0,0,1,0,4.065Z",
    transform: "translate(-48.002 -28.01)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42",
    "data-name": "Grupo 42",
    transform: "translate(7.761 8.126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_153",
    "data-name": "Trazado 153",
    d: "M62.619,54.344a.246.246,0,0,1-.039,0H50.941a1.888,1.888,0,0,1-1.372-.6A2.089,2.089,0,0,1,49,52.312L49,34.04a1.987,1.987,0,0,1,1.94-2.032H62.579a1.987,1.987,0,0,1,1.94,2.032l0,17.865a2.152,2.152,0,0,1,.039.406A1.987,1.987,0,0,1,62.619,54.344Zm-9.738-4.065H60.64l0-14.206H52.883Z",
    transform: "translate(-49.001 -32.008)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_43",
    "data-name": "Grupo 43",
    transform: "translate(19.401 26.394)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_154",
    "data-name": "Trazado 154",
    d: "M58.88,51.161a1.948,1.948,0,0,1-1.839-1.39l-1.94-6.1A2.054,2.054,0,0,1,56.327,41.1a1.917,1.917,0,0,1,2.454,1.284l1.94,6.1A2.054,2.054,0,0,1,59.5,51.055a1.882,1.882,0,0,1-.615.106Z",
    transform: "translate(-55 -40.997)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_44",
    "data-name": "Grupo 44",
    transform: "translate(5.821 26.395)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_155",
    "data-name": "Trazado 155",
    d: "M49.941,51.161a1.862,1.862,0,0,1-.613-.106A2.055,2.055,0,0,1,48.1,48.484l1.94-6.1A1.917,1.917,0,0,1,52.5,41.1a2.055,2.055,0,0,1,1.226,2.571l-1.94,6.1a1.952,1.952,0,0,1-1.841,1.39Z",
    transform: "translate(-48.001 -40.997)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_45",
    "data-name": "Grupo 45",
    transform: "translate(5.821 32.494)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_156",
    "data-name": "Trazado 156",
    d: "M57.7,50.1c-4.721,0-7.542-.679-8.884-2.13a2.838,2.838,0,0,1-.813-2A1.985,1.985,0,0,1,49.939,44c.021,0,.041,0,.062,0a1.943,1.943,0,0,1,1.713,1.2c.4.222,1.855.825,5.986.827s5.592-.6,5.988-.825A1.938,1.938,0,0,1,65.4,44c.021,0,.041,0,.062,0A1.985,1.985,0,0,1,67.4,45.967a2.838,2.838,0,0,1-.815,2C65.241,49.418,62.418,50.1,57.7,50.1Z",
    transform: "translate(-48.001 -43.998)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_46",
    "data-name": "Grupo 46",
    transform: "translate(9.703 46.713)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_157",
    "data-name": "Trazado 157",
    d: "M59.7,55.059H51.942a2.035,2.035,0,0,1,0-4.065H59.7a2.035,2.035,0,0,1,0,4.065Z",
    transform: "translate(-50.002 -50.994)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_47",
    "data-name": "Grupo 47",
    transform: "translate(25.221 26.397)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_158",
    "data-name": "Trazado 158",
    d: "M61.88,45.063H59.94a2.035,2.035,0,0,1,0-4.065h1.94a2.035,2.035,0,0,1,0,4.065Z",
    transform: "translate(-58 -40.998)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_48",
    "data-name": "Grupo 48",
    transform: "translate(0 26.397)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_159",
    "data-name": "Trazado 159",
    d: "M48.881,45.063h-1.94a2.035,2.035,0,0,1,0-4.065h1.94a2.035,2.035,0,0,1,0,4.065Z",
    transform: "translate(-45.001 -40.998)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_49",
    "data-name": "Grupo 49",
    transform: "translate(3.305 1.128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_160",
    "data-name": "Trazado 160",
    d: "M53.1,39.627a1.914,1.914,0,0,1-1.616-.9l-4.457-7a2.091,2.091,0,0,1,.537-2.819,1.888,1.888,0,0,1,2.691.563l4.457,7a2.091,2.091,0,0,1-.537,2.819A1.881,1.881,0,0,1,53.1,39.627Z",
    transform: "translate(-46.704 -28.565)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_50",
    "data-name": "Grupo 50",
    transform: "translate(19.399 1.128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_161",
    "data-name": "Trazado 161",
    d: "M56.939,39.623a1.881,1.881,0,0,1-1.075-.341,2.091,2.091,0,0,1-.537-2.819l4.457-6.993a1.887,1.887,0,0,1,2.691-.563,2.091,2.091,0,0,1,.537,2.819l-4.457,6.993a1.917,1.917,0,0,1-1.616.9Z",
    transform: "translate(-54.999 -28.565)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_70",
    "data-name": "Grupo 70",
    transform: "translate(46.564 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_55",
    "data-name": "Grupo 55",
    transform: "translate(1.94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_52",
    "data-name": "Grupo 52",
    transform: "translate(0.002 4.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_162",
    "data-name": "Trazado 162",
    d: "M26.941,47.583A1.986,1.986,0,0,1,25,45.551V11.032a1.942,1.942,0,1,1,3.88,0V45.551A1.986,1.986,0,0,1,26.941,47.583Z",
    transform: "translate(-25.001 -9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_53",
    "data-name": "Grupo 53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_163",
    "data-name": "Trazado 163",
    d: "M26.94,15.126A1.986,1.986,0,0,1,25,13.093,5.97,5.97,0,0,1,30.823,7a1.986,1.986,0,0,1,1.94,2.032,1.986,1.986,0,0,1-1.94,2.032,1.988,1.988,0,0,0-1.942,2.028A1.986,1.986,0,0,1,26.94,15.126Z",
    transform: "translate(-25 -7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_54",
    "data-name": "Grupo 54",
    transform: "translate(0.002 38.583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_164",
    "data-name": "Trazado 164",
    d: "M34.7,38.178A9.423,9.423,0,0,1,27.841,35.2,10.337,10.337,0,0,1,25,28.016a1.942,1.942,0,1,1,3.88,0,6.209,6.209,0,0,0,1.7,4.313A5.655,5.655,0,0,0,34.7,34.114a2.035,2.035,0,0,1,0,4.065Z",
    transform: "translate(-25.001 -25.984)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_59",
    "data-name": "Grupo 59",
    transform: "translate(17.458)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_56",
    "data-name": "Grupo 56",
    transform: "translate(7.763 4.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_165",
    "data-name": "Trazado 165",
    d: "M38.939,47.585A1.986,1.986,0,0,1,37,45.553V11.03a1.942,1.942,0,1,1,3.88,0V45.553A1.986,1.986,0,0,1,38.939,47.585Z",
    transform: "translate(-36.999 -8.998)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57",
    "data-name": "Grupo 57",
    transform: "translate(3.882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_166",
    "data-name": "Trazado 166",
    d: "M40.82,15.126a1.986,1.986,0,0,1-1.94-2.032,1.986,1.986,0,0,0-1.94-2.028A1.986,1.986,0,0,1,35,9.032,1.986,1.986,0,0,1,36.939,7a5.969,5.969,0,0,1,5.821,6.093A1.986,1.986,0,0,1,40.82,15.126Z",
    transform: "translate(-34.999 -7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58",
    "data-name": "Grupo 58",
    transform: "translate(0 38.583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_167",
    "data-name": "Trazado 167",
    d: "M34.938,38.178a2.035,2.035,0,0,1,0-4.065,5.973,5.973,0,0,0,5.823-6.1,1.942,1.942,0,1,1,3.88,0A9.951,9.951,0,0,1,34.938,38.178Z",
    transform: "translate(-32.998 -25.984)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_60",
    "data-name": "Grupo 60",
    transform: "translate(5.823)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_168",
    "data-name": "Trazado 168",
    d: "M44.459,11.065H28.941A1.986,1.986,0,0,1,27,9.032,1.986,1.986,0,0,1,28.941,7H44.459A1.986,1.986,0,0,1,46.4,9.032,1.986,1.986,0,0,1,44.459,11.065Z",
    transform: "translate(-27.001 -7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_61",
    "data-name": "Grupo 61",
    transform: "translate(7.761 8.126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_169",
    "data-name": "Trazado 169",
    d: "M29.94,33.334a1.888,1.888,0,0,1-1.372-.6A2.086,2.086,0,0,1,28,31.3L28,13.03A1.987,1.987,0,0,1,29.942,11H41.578a1.987,1.987,0,0,1,1.94,2.032l0,18.267a1.987,1.987,0,0,1-1.94,2.032Zm1.942-18.271,0,14.206,7.759,0,0-14.2Z",
    transform: "translate(-28 -10.998)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_62",
    "data-name": "Grupo 62",
    transform: "translate(19.401 26.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_170",
    "data-name": "Trazado 170",
    d: "M37.879,30.149a1.948,1.948,0,0,1-1.839-1.39l-1.94-6.1a2.054,2.054,0,0,1,1.226-2.571,1.918,1.918,0,0,1,2.454,1.284l1.94,6.1a2.054,2.054,0,0,1-1.226,2.571,1.821,1.821,0,0,1-.615.106Z",
    transform: "translate(-33.999 -19.985)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_63",
    "data-name": "Grupo 63",
    transform: "translate(5.821 26.394)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_171",
    "data-name": "Trazado 171",
    d: "M28.94,30.147a1.862,1.862,0,0,1-.613-.106A2.056,2.056,0,0,1,27.1,27.471l1.94-6.093A1.915,1.915,0,0,1,31.5,20.093a2.056,2.056,0,0,1,1.226,2.571l-1.94,6.093A1.949,1.949,0,0,1,28.94,30.147Z",
    transform: "translate(-27 -19.987)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_64",
    "data-name": "Grupo 64",
    transform: "translate(5.821 32.488)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_172",
    "data-name": "Trazado 172",
    d: "M36.7,29.084c-4.717,0-7.54-.677-8.882-2.128a2.838,2.838,0,0,1-.815-2,1.926,1.926,0,0,1,3.712-.762c.4.222,1.853.825,5.986.825s5.592-.6,5.987-.825A1.938,1.938,0,0,1,44.4,22.989a1.986,1.986,0,0,1,2,1.967,2.852,2.852,0,0,1-.817,2c-1.343,1.451-4.166,2.128-8.884,2.128Z",
    transform: "translate(-27 -22.985)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_65",
    "data-name": "Grupo 65",
    transform: "translate(9.703 46.713)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_173",
    "data-name": "Trazado 173",
    d: "M38.7,34.049H30.941a2.035,2.035,0,0,1,0-4.065H38.7a2.035,2.035,0,0,1,0,4.065Z",
    transform: "translate(-29.001 -29.984)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_66",
    "data-name": "Grupo 66",
    transform: "translate(25.221 26.393)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_174",
    "data-name": "Trazado 174",
    d: "M40.879,24.051h-1.94a2.035,2.035,0,0,1,0-4.065h1.94a2.035,2.035,0,0,1,0,4.065Z",
    transform: "translate(-36.999 -19.986)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_67",
    "data-name": "Grupo 67",
    transform: "translate(0 26.393)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_175",
    "data-name": "Trazado 175",
    d: "M27.88,24.051H25.94a2.035,2.035,0,0,1,0-4.065h1.94a2.035,2.035,0,0,1,0,4.065Z",
    transform: "translate(-24 -19.986)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_68",
    "data-name": "Grupo 68",
    transform: "translate(3.305 1.124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_176",
    "data-name": "Trazado 176",
    d: "M32.1,18.619a1.914,1.914,0,0,1-1.616-.9l-4.457-7a2.091,2.091,0,0,1,.537-2.819,1.889,1.889,0,0,1,2.691.563l4.457,7a2.091,2.091,0,0,1-.537,2.819,1.885,1.885,0,0,1-1.075.341Z",
    transform: "translate(-25.703 -7.553)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_69",
    "data-name": "Grupo 69",
    transform: "translate(19.399 1.124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_177",
    "data-name": "Trazado 177",
    d: "M35.938,18.615a1.881,1.881,0,0,1-1.075-.341,2.091,2.091,0,0,1-.537-2.819l4.457-7a1.888,1.888,0,0,1,2.691-.563,2.091,2.091,0,0,1,.537,2.819l-4.457,7a1.914,1.914,0,0,1-1.616.9Z",
    transform: "translate(-33.998 -7.553)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_89",
    "data-name": "Grupo 89",
    transform: "translate(5.826 49.701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_74",
    "data-name": "Grupo 74",
    transform: "translate(1.94 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_71",
    "data-name": "Grupo 71",
    transform: "translate(0.002 4.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_178",
    "data-name": "Trazado 178",
    d: "M5.944,68.593A1.986,1.986,0,0,1,4,66.561V32.042a1.986,1.986,0,0,1,1.94-2.032,1.986,1.986,0,0,1,1.94,2.032V66.561A1.986,1.986,0,0,1,5.944,68.593Z",
    transform: "translate(-4.004 -30.01)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_72",
    "data-name": "Grupo 72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_179",
    "data-name": "Trazado 179",
    d: "M5.943,36.14A1.986,1.986,0,0,1,4,34.107a5.973,5.973,0,0,1,5.823-6.1,2.035,2.035,0,0,1,0,4.065,1.99,1.99,0,0,0-1.942,2.032A1.986,1.986,0,0,1,5.943,36.14Z",
    transform: "translate(-4.003 -28.01)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_73",
    "data-name": "Grupo 73",
    transform: "translate(0.002 38.583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_180",
    "data-name": "Trazado 180",
    d: "M13.705,59.188a9.429,9.429,0,0,1-6.861-2.973A10.338,10.338,0,0,1,4,49.026a1.987,1.987,0,0,1,1.94-2.032,1.987,1.987,0,0,1,1.94,2.032,6.2,6.2,0,0,0,1.7,4.313,5.652,5.652,0,0,0,4.117,1.784,2.035,2.035,0,0,1,0,4.065Z",
    transform: "translate(-4.004 -46.994)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_78",
    "data-name": "Grupo 78",
    transform: "translate(17.458 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_75",
    "data-name": "Grupo 75",
    transform: "translate(7.763 4.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_181",
    "data-name": "Trazado 181",
    d: "M17.942,68.593A1.986,1.986,0,0,1,16,66.561V32.042a1.942,1.942,0,1,1,3.88,0V66.561A1.986,1.986,0,0,1,17.942,68.593Z",
    transform: "translate(-16.002 -30.01)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_76",
    "data-name": "Grupo 76",
    transform: "translate(3.882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_182",
    "data-name": "Trazado 182",
    d: "M19.823,36.14a1.986,1.986,0,0,1-1.94-2.032,1.989,1.989,0,0,0-1.94-2.032,2.035,2.035,0,0,1,0-4.065,5.971,5.971,0,0,1,5.821,6.1A1.986,1.986,0,0,1,19.823,36.14Z",
    transform: "translate(-14.002 -28.01)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_77",
    "data-name": "Grupo 77",
    transform: "translate(0 38.583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_183",
    "data-name": "Trazado 183",
    d: "M13.941,59.188a2.035,2.035,0,0,1,0-4.065,5.973,5.973,0,0,0,5.823-6.1,1.942,1.942,0,1,1,3.88,0,9.951,9.951,0,0,1-9.7,10.162Z",
    transform: "translate(-12.001 -46.994)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_79",
    "data-name": "Grupo 79",
    transform: "translate(5.823 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_184",
    "data-name": "Trazado 184",
    d: "M23.462,32.075H7.944a2.035,2.035,0,0,1,0-4.065H23.462a2.035,2.035,0,0,1,0,4.065Z",
    transform: "translate(-6.004 -28.01)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_80",
    "data-name": "Grupo 80",
    transform: "translate(7.761 8.126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_185",
    "data-name": "Trazado 185",
    d: "M20.619,54.344a.242.242,0,0,1-.039,0H8.943a1.888,1.888,0,0,1-1.372-.6A2.089,2.089,0,0,1,7,52.312L7,34.04a1.987,1.987,0,0,1,1.94-2.032H20.581a1.987,1.987,0,0,1,1.94,2.032l0,17.865a2.152,2.152,0,0,1,.039.406A1.989,1.989,0,0,1,20.619,54.344Zm-9.736-4.065h7.759l0-14.206H10.885Z",
    transform: "translate(-7.003 -32.008)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_81",
    "data-name": "Grupo 81",
    transform: "translate(19.401 26.394)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_186",
    "data-name": "Trazado 186",
    d: "M16.882,51.161a1.948,1.948,0,0,1-1.839-1.39l-1.94-6.1A2.054,2.054,0,0,1,14.329,41.1a1.917,1.917,0,0,1,2.454,1.284l1.94,6.1A2.054,2.054,0,0,1,17.5,51.055,1.882,1.882,0,0,1,16.882,51.161Z",
    transform: "translate(-13.002 -40.997)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_82",
    "data-name": "Grupo 82",
    transform: "translate(5.821 26.395)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_187",
    "data-name": "Trazado 187",
    d: "M7.943,51.161a1.862,1.862,0,0,1-.613-.106A2.055,2.055,0,0,1,6.1,48.484l1.94-6.1A1.917,1.917,0,0,1,10.5,41.1a2.055,2.055,0,0,1,1.226,2.571l-1.94,6.1A1.952,1.952,0,0,1,7.943,51.161Z",
    transform: "translate(-6.003 -40.997)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_83",
    "data-name": "Grupo 83",
    transform: "translate(5.821 32.494)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_188",
    "data-name": "Trazado 188",
    d: "M15.7,50.1c-4.721,0-7.542-.679-8.884-2.13a2.838,2.838,0,0,1-.813-2A1.985,1.985,0,0,1,7.941,44c.021,0,.041,0,.062,0a1.943,1.943,0,0,1,1.713,1.2c.4.222,1.855.825,5.986.827s5.592-.6,5.988-.825A1.938,1.938,0,0,1,23.4,44c.021,0,.041,0,.062,0A1.985,1.985,0,0,1,25.4,45.967a2.838,2.838,0,0,1-.815,2C23.243,49.418,20.42,50.1,15.7,50.1Z",
    transform: "translate(-6.003 -43.998)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_84",
    "data-name": "Grupo 84",
    transform: "translate(9.703 46.713)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_189",
    "data-name": "Trazado 189",
    d: "M17.7,55.059H9.944a2.035,2.035,0,0,1,0-4.065H17.7a2.035,2.035,0,0,1,0,4.065Z",
    transform: "translate(-8.004 -50.994)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_85",
    "data-name": "Grupo 85",
    transform: "translate(25.221 26.397)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_190",
    "data-name": "Trazado 190",
    d: "M19.882,45.063h-1.94a2.035,2.035,0,0,1,0-4.065h1.94a2.035,2.035,0,0,1,0,4.065Z",
    transform: "translate(-16.002 -40.998)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_86",
    "data-name": "Grupo 86",
    transform: "translate(0 26.397)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_191",
    "data-name": "Trazado 191",
    d: "M6.883,45.063H4.943a2.035,2.035,0,0,1,0-4.065h1.94a2.035,2.035,0,0,1,0,4.065Z",
    transform: "translate(-3.003 -40.998)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_87",
    "data-name": "Grupo 87",
    transform: "translate(3.305 1.128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_192",
    "data-name": "Trazado 192",
    d: "M11.106,39.627a1.914,1.914,0,0,1-1.616-.9l-4.457-7a2.091,2.091,0,0,1,.537-2.819,1.888,1.888,0,0,1,2.691.563l4.457,7a2.091,2.091,0,0,1-.537,2.819A1.881,1.881,0,0,1,11.106,39.627Z",
    transform: "translate(-4.706 -28.565)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_88",
    "data-name": "Grupo 88",
    transform: "translate(19.399 1.128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_193",
    "data-name": "Trazado 193",
    d: "M14.941,39.623a1.881,1.881,0,0,1-1.075-.341,2.091,2.091,0,0,1-.537-2.819l4.457-6.993a1.888,1.888,0,0,1,2.691-.563,2.091,2.091,0,0,1,.537,2.819l-4.457,6.993a1.917,1.917,0,0,1-1.616.9Z",
    transform: "translate(-13.001 -28.565)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_90",
    "data-name": "Grupo 90",
    transform: "translate(60.146 61.858)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_194",
    "data-name": "Trazado 194",
    d: "M32.94,72.616A1.986,1.986,0,0,1,31,70.583V36.024a1.942,1.942,0,1,1,3.88,0V70.583a1.986,1.986,0,0,1-1.94,2.032Z",
    transform: "translate(-31 -33.992)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_91",
    "data-name": "Grupo 91",
    transform: "translate(60.145 92.352)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_195",
    "data-name": "Trazado 195",
    d: "M32.94,57.126a1.891,1.891,0,0,1-1.372-.6,2.1,2.1,0,0,1,0-2.874l3.88-4.065a1.877,1.877,0,0,1,2.743,0,2.1,2.1,0,0,1,0,2.874l-3.88,4.065A1.891,1.891,0,0,1,32.94,57.126Z",
    transform: "translate(-31 -48.996)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_92",
    "data-name": "Grupo 92",
    transform: "translate(56.265 92.352)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_196",
    "data-name": "Trazado 196",
    d: "M34.821,57.126a1.891,1.891,0,0,1-1.372-.6l-3.88-4.065a2.1,2.1,0,0,1,0-2.874,1.877,1.877,0,0,1,2.743,0l3.88,4.065a2.1,2.1,0,0,1,0,2.874A1.891,1.891,0,0,1,34.821,57.126Z",
    transform: "translate(-29 -48.996)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingScene);
export default __webpack_public_path__ + "static/media/parking-scene.876202c7b5086fa83aa7da173be4edd5.svg";
export { ForwardRef as ReactComponent };